import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function QoochanStats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="qcc" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="qcc" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="qcc" />
    </>
  );
}
export default QoochanStats;